import { NgModule } from "@angular/core";
import { CoreModule } from "../../../core/core.module";
import { SharedModule } from "../../../shared/shared.module";
import { CompaniesComponent } from "./companies.component";
import { CompanyBulkUploadComponent } from "./company-bulk-upload/company-bulk-upload.component";
import { CreateCompanyComponent } from "./create-company/create-company.component";
import { ManageCompanyComponent } from "./manage-company/manage-company.component";

@NgModule({
  declarations: [CompaniesComponent, CompanyBulkUploadComponent, CreateCompanyComponent, ManageCompanyComponent],
  imports: [CoreModule, SharedModule],
  exports: [CompaniesComponent, CompanyBulkUploadComponent, CreateCompanyComponent, ManageCompanyComponent],
})
export class CompanyModule {}
